const _ = require('lodash');
const { appyDealsCheck } = require('../../../common/utility/appyDealsCheck');
const BadgeController = require('../badges/badge-controller');

module.exports = function (shelfProductService) {
    return {
        restrict: 'E',
        controller: BadgeController,
        controllerAs: 'ctrl',
        bindToController: {
            stockcodes: '=',
            imgSize: '@?',
            hideSave: '=?',
            hideImage: '=?',
            promo: '@?',
            templateClass: '@?'
        },
        scope: {},
        link(scope) {
            scope.ctrl = scope.ctrl || {};
            scope.loading = true;

            function transformAdditionalDetails(product) {
                return angular.forEach(product.AdditionalDetails, function (item) {
                    product[item.Name] = item.Value;
                });
            }

            function showSavingsBadge(product) {
                return (!product.HideWasSavedPrice && product.SavingsAmount > 0)
                    || product.PercentageOffTag.SavedAmount > 0 && product.PercentageOffTag.TagType !== 'None'
                    || product.FixedPricePromoTag.SavedAmount > 0 && product.FixedPricePromoTag.TagType !== 'None';
            }

            function handleSavingsBadge(product) {
                product.showSavingsBadge = showSavingsBadge(product);
            }

            function isShowAppyDeals(product) {
                return product && appyDealsCheck(product);
            }

            const stockcodes = _.map(scope.ctrl.stockcodes, (item) => { return item.stockcode; });

            shelfProductService.getProductDetail(stockcodes).then(function (products) {

                //Clean the response and create var on the scope
                scope.products = products.plain();

                _.map(products, function (product, i) {
                    transformAdditionalDetails(product);

                    //Add a class to the container
                    product.productPosClass = 'dc-promo-pos--' + (i + 1);


                    //Override the top and bottom text if passed in as part of the stockcodes object
                    if (scope.ctrl != null && scope.ctrl.stockcodes != null && scope.ctrl.stockcodes.length > 0
                        && scope.ctrl.stockcodes[i].topText !== null && scope.ctrl.stockcodes[i].topText !== '') {
                        product.topText = scope.ctrl.stockcodes[i].topText;
                    }

                    if (scope.ctrl != null && scope.ctrl.stockcodes != null && scope.ctrl.stockcodes.length > 0
                        && scope.ctrl.stockcodes[i].bottomText !== null && scope.ctrl.stockcodes[i].bottomText !== '') {
                        product.bottomText = scope.ctrl.stockcodes[i].bottomText;
                    }

                    switch (scope.ctrl.promo) {
                        case 'fixed':
                            product.promoPrice = product.FixedPricePromoTag.PromotionalPrice;
                            product.savingsAmount = product.FixedPricePromoTag.SavedAmount;
                            break;
                        case 'percentage':
                            product.promoPrice = product.PercentageOffTag.PromotionalPrice;
                            product.savingsAmount = product.PercentageOffTag.SavedAmount;
                            break;
                        case 'sale-price':
                            product.promoPrice = product.SalePrice;
                            product.savingsAmount = product.SavingsAmount;
                            break;
                        case 'list-price' :
                            product.promoPrice = product.Price;
                            product.savingsAmount = product.SavingsAmount;
                            break;
                        default:
                            product.promoPrice = product.Price;
                            product.savingsAmount = product.SavingsAmount;
                            break;
                    }

                    handleSavingsBadge(product);

                    // appy deals display logic
                    scope.ctrl.showAppyDeals = isShowAppyDeals(product);
                });
            }).finally(function () {
                scope.loading = false;
            });

        },

        template: require('./dynamic-content-product-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/dynamiccontent/dynamic-content-product-directive.js
 **/